import { useMemo } from "react";
import { Card, CardContent, Grid, Typography } from "@mui/material";
import { useFormikContext } from "formik";

import RpCurrencyField from "@/components/muiCustom/textField/RpCurrencyField";
import { rrdDirectMailCampaignHelper } from "@/features/campaigns/direct-mail/rrd/utils/rrdDirectMailHelper";

function RRDTotalBudget() {
  const { values } = useFormikContext();

  const total = useMemo(() => {
    if (!values) return 0;
    const fullyFilledLocations =
      rrdDirectMailCampaignHelper.fetchFullyFilledLocations(values);

    return rrdDirectMailCampaignHelper.getLocationsTotalBudget(
      fullyFilledLocations || []
    );
  }, [values]);

  return (
    <Card sx={{ mt: 7 }}>
      <CardContent>
        <Grid
          container
          spacing={2}
          justifyContent="flex-end"
          alignItems="center"
        >
          <Grid size={{ xs: 12, sm: "auto" }}>
            <Typography variant="body2" fontWeight={700}>
              Your Total Campaign Budget
            </Typography>
          </Grid>
          <Grid size={{ xs: 12, sm: "auto" }}>
            <RpCurrencyField
              value={total}
              readOnly
              placeholder="0.00"
              fixedDecimalScale={true}
            />
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
}

export default RRDTotalBudget;
